module.exports = __webpack_public_path__ + "static/scan-2-10fffa4f7033c9595a98eb309e7fc5f2.png";